import AuthService from '../../../Services/authService';
import OpportunitySecurityChecklistService from '../../../Services/opportunitySecurityChecklistService';
import CommentService from '../../../Services/CommentService';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

// Static description for the Section B "Retention Details" log (see GeneralEntryLogFigma): an append-only
// free-text log of plain Comments on the OpportunitySecurityChecklist entity type (73), keyed by the
// OpportunitySecurityChecklistId. Reads go through the generic CommentService by checklist id; the add posts the
// OpportunityId to the checklist controller, which resolves that id, stores the comment and mirrors a breadcrumb
// onto the Opportunity's Comments tab. OpportunitySecurityChecklistTab supplies the live context.
export default class OpportunityRetentionDetailEntryLogDescription {
  //#region List
  // Carries the read-only Retain Until date, so the tab needs no separate banner element.
  static title = (ctx) => `Retention Details — Retain data until: ${ctx.retainUntilDisplay || 'Not set'}`;
  static errorCode = 'ORDLD15';

  static populate = (ctx) =>
    ctx.checklistExists
      ? CommentService.GetCommentsByEntityTypeIdAndEntityId(ctx.entityTypeId, ctx.opportunitySecurityChecklistId)
      : Promise.resolve([]);

  static convert = (rows) => CommentService.ConvertDBItem(rows);

  static metaAttribution = {
    attributionPrefix: 'Added by',
    authorNameKey: 'CreatedByName',
    timestampKey: 'CreatedOn',
  };

  static renderBody = (comment) => comment.Message;
  //#endregion

  //#region Add
  static addField = {
    type: InputTypesEnum.TextBox2,
    initialValue: '',
    label: null,
    placeholder: 'Type the retention detail...',
    isValid: (value) => value !== '',
  };

  // The add button stays visible and is greyed out with the reason that blocks it. Unlike the completion logs,
  // details need no Won Opportunity: the retention terms are agreed before the contract is won. Whether Data
  // Retention is defined deliberately plays no part: a detail may be logged either way. The server checks the
  // same two conditions.
  static addDisabledReason = (ctx) => {
    if (!ctx.checklistExists) {
      return 'Save the Security Checklist first.';
    }
    if (!AuthService.HasRole('OpportunityEdit')) {
      return 'You do not have permission to add retention details.';
    }
    return null;
  };

  // Single source for the panel's contextual notice (no checklist yet / empty).
  static stateMessage = (ctx) => (ctx.checklistExists ? null : 'Save the Security Checklist first.');

  static addEntry = (value, ctx) =>
    OpportunitySecurityChecklistService.AddRetentionDetail(ctx.entityTypeId, ctx.opportunityId, value);
  //#endregion
}
